import { useSnackbar as useSnackbar_ } from "./SnackbarProvider.ts";

// todo: remove this export
export const useSnackbar = useSnackbar_;
